<template>
  <div v-click-outside="closeHeaderAccount" class="header-account-action">
    <oie-the-header-account-popup v-if="isAccountOptionsOpen"></oie-the-header-account-popup>

    <button class="header-account-action__button" @click="toggleValue({key: 'isAccountOptionsOpen'})">
      <oie-base-icon icon="user"></oie-base-icon>
      {{ userInfo }}
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('ui', ['isAccountOptionsOpen']),
    userInfo() {
      if(this.clientModel.impersonating) {
        return this.clientModel.impersonating.superUserName
      } else {
        return this.clientModel.user.firstName || this.clientModel.user.lastName
          ? this.clientModel.user.isCompanyCustomer
            ? `${this.clientModel.user.firstName} ${this.clientModel.user.lastName} | ${this.clientModel.user.customerName}`
            : `${this.clientModel.user.firstName} ${this.clientModel.user.lastName} - ${this.tStatic('myAccountMenuItemTitle')}`
          : `${this.clientModel.user.customerName} - ${this.tStatic('myAccountMenuItemTitle')}`
      }
    }
  },
  methods: {
    ...mapActions('ui', ['toggleValue']),
    closeHeaderAccount() {
      if (this.isAccountOptionsOpen) {
        this.toggleValue({ key: 'isAccountOptionsOpen', value: false })
      }
    }
  }
}
</script>

<style lang="scss">
.header-account-action {
  position: relative;
}

.header-account-action__button {
  @include reset-button;
}
</style>
